'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Entry.FieldBlock = /*#__PURE__*/function (_Entry$Field) {
  function FieldBlock(content, blockView, index, mode, contentIndex) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldBlock);
    _this = _callSuper(this, FieldBlock, [content, blockView, index, mode, contentIndex]);
    (0, _defineProperty2["default"])(_this, "getBlockType", function () {
      return 'field';
    });
    Entry.Model(_this, false);
    _this._blockView = blockView;
    _this._block = blockView.block;
    _this._valueBlock = null;
    _this._oldPrimitiveValue = null;
    _this.box = new Entry.BoxModel();
    _this.changeEvent = new Entry.Event(_this);
    _this._index = index;
    _this.contentIndex = contentIndex;
    _this._content = content;
    _this.acceptType = content.accept;
    _this.defaultType = content.defaultType;
    _this._restoreCurrent = content.restore;
    _this.view = _this;
    _this.svgGroup = null;
    _this._position = content.position;
    _this.observe(_this, '_updateBG', ['magneting'], false);
    _this.renderStart(_this.getBoard(), mode);
    _this.schema = {
      magneting: false
    };
    _this.calcHeight = _this.calcWH;
    _this.doSeparate = _this.separate;
    return _this;
  }
  (0, _inherits2["default"])(FieldBlock, _Entry$Field);
  return (0, _createClass2["default"])(FieldBlock, [{
    key: "getBoard",
    value: function getBoard() {
      return _.result(this._blockView, 'getBoard');
    }
  }, {
    key: "getBlockList",
    value: function getBlockList(excludePrimitive, type) {
      var value = this.value;
      try {
        return _.chain(value.getBlockList(excludePrimitive, type)).flatten().compact().value();
      } catch (e) {
        console.log(e);
        return [];
      }
    }
  }, {
    key: "stringify",
    value: function stringify(excludeData, isNew) {
      try {
        return JSON.stringify(this.toJSON(isNew, undefined, excludeData));
      } catch (e) {
        console.error(e);
        return '';
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON(isNew, index, excludeData, option) {
      try {
        var value = this.value;
        return [value.toJSON(isNew, excludeData, option)];
      } catch (e) {
        console.error(e);
        return [];
      }
    }
  }, {
    key: "renderStart",
    value: function renderStart(board, mode, renderMode, isReDraw) {
      if (!this.svgGroup) {
        this.svgGroup = this._blockView.contentSvgGroup.elem('g');
      }
      this.renderMode = !_.isUndefined(mode) ? mode : this._blockView.renderMode;
      this.view = this;
      this._nextGroup = this.svgGroup;
      this.updateValueBlock(this.getValue());
      var valueBlockView = this._valueBlock.view;
      valueBlockView.renderByMode(this.renderMode, isReDraw);
      if (this.getBoard().constructor !== Entry.Board) {
        valueBlockView.removeControl();
      }
      this.box.observe(this._blockView, 'dAlignContent', ['width', 'height'], false);
    }
  }, {
    key: "align",
    value: function align(x, y) {
      var animate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var svgGroup = this.svgGroup;
      if (this._position) {
        if (this._position.x) {
          x = this._position.x;
        }
        if (this._position.y) {
          y = this._position.y;
        }
      }
      var blockView = _.result(this._valueBlock, 'view');
      if (y === 0 && blockView) {
        y = blockView.height * -0.5;
      } else if (y > 0) {
        y = y - 10;
      }
      if (!(x || y)) {
        svgGroup.removeAttr('transform');
      } else {
        var transform = "translate(".concat(x, ",").concat(y, ")");
        if (animate) {
          svgGroup.animate({
            transform: transform
          }, 300, mina.easeinout);
        } else {
          svgGroup.attr({
            transform: transform
          });
        }
      }
      x = Math.round(x * 100) / 100;
      y = Math.round(y * 100) / 100;
      var box = this.box;
      if (box.x === x && box.y === y) {
        return;
      }
      box.set({
        x: x,
        y: y
      });
    }
  }, {
    key: "calcWH",
    value: function calcWH() {
      var block = this._valueBlock;
      var box = this.box;
      var oldWidth = box.width;
      var oldHeight = box.height;
      var newWidth;
      var newHeight;
      var blockView = block && block.view;
      if (blockView) {
        newWidth = blockView.width;
        newHeight = blockView.height;
      } else {
        newWidth = 15;
        newHeight = 20;
      }
      if (newWidth !== oldWidth) {
        box.set({
          width: newWidth
        });
      }
      if (newHeight !== oldHeight) {
        box.set({
          height: newHeight
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _.result(this._valueBlock, 'destroyView');
    }
  }, {
    key: "inspectBlock",
    value: function inspectBlock() {
      var blockType = null;
      if (this._originBlock) {
        blockType = this._originBlock.type;
        delete this._originBlock;
      } else if (this._content.blockType) {
        blockType = this._content.blockType;
      } else if (this._content.defaultType) {
        blockType = this._content.defaultType;
      } else {
        switch (this.acceptType.toLowerCase()) {
          case 'boolean':
            blockType = 'True';
            break;
          case 'string':
            blockType = 'text';
            break;
          case 'number':
            blockType = 'number';
            break;
          case 'param':
          default:
            blockType = 'function_field_label';
            break;
        }
      }
      return this._createBlockByType(blockType);
    }
  }, {
    key: "_setValueBlock",
    value: function _setValueBlock(block) {
      if (this._restoreCurrent) {
        this._originBlock = this._valueBlock;
      }
      block = block || this.inspectBlock();
      this._valueBlock = block;
      this.setValue(block);
      block.setThread(this);
      this.view.setParent(this);
      return this._valueBlock;
    }
  }, {
    key: "getValueBlock",
    value: function getValueBlock() {
      return this._valueBlock;
    }
  }, {
    key: "updateValueBlock",
    value: function updateValueBlock(block) {
      if (!(block instanceof Entry.Block)) {
        block = undefined;
      }
      block = this._ensureBlock(block);
      if (block && block === this._valueBlock) {
        return this.calcWH();
      }
      this._destroyObservers();
      var _this$_setValueBlock = this._setValueBlock(block),
        view = _this$_setValueBlock.view;
      view.bindPrev(this);
      this._blockView.alignContent();
      this._posObserver = view.observe(this, 'updateValueBlock', ['x', 'y'], false);
      this._sizeObserver = view.observe(this, 'calcWH', ['width', 'height']);
    }
  }, {
    key: "_destroyObservers",
    value: function _destroyObservers() {
      var _destroyFunc = _.partial(_.result, _, 'destroy');
      _destroyFunc(this._sizeObserver);
      _destroyFunc(this._posObserver);
    }
  }, {
    key: "getPrevBlock",
    value: function getPrevBlock(block) {
      if (this._valueBlock === block) {
        return this;
      } else {
        return null;
      }
    }
  }, {
    key: "getNextBlock",
    value: function getNextBlock() {
      return null;
    }
  }, {
    key: "requestAbsoluteCoordinate",
    value: function requestAbsoluteCoordinate(blockView) {
      var board = this.getBoard();
      var _ref = board || {},
        _ref$scale = _ref.scale,
        scale = _ref$scale === void 0 ? 1 : _ref$scale;
      var blockView = this._blockView;
      var contentPos = blockView.contentPos;
      var pos = blockView.getAbsoluteCoordinate();
      pos.x += (this.box.x + contentPos.x) * scale;
      pos.y += this.box.y + contentPos.y;
      return pos;
    }
  }, {
    key: "requestPartHeight",
    value: function requestPartHeight(blockView, forAll) {
      return blockView ? blockView.magnet.next ? blockView.magnet.next.y : blockView.height : 0;
    }
  }, {
    key: "getCount",
    value: function getCount() {
      return 0;
    }
  }, {
    key: "dominate",
    value: function dominate() {
      this._blockView.dominate();
    }
  }, {
    key: "isGlobal",
    value: function isGlobal() {
      return false;
    }
  }, {
    key: "separate",
    value: function separate(block) {
      this.getCode().createThread([block]);
      this.calcWH();
      this.changeEvent.notify();
    }
  }, {
    key: "getCode",
    value: function getCode() {
      return this._block.thread.getCode();
    }
  }, {
    key: "cut",
    value: function cut(block) {
      if (this._valueBlock === block) {
        return [block];
      }
      return null;
    }
  }, {
    key: "replace",
    value: function replace(block) {
      if (typeof block === 'string') {
        block = this._createBlockByType(block);
      }
      var valueBlock = this._valueBlock;
      if (Entry.block[valueBlock.type].isPrimitive) {
        valueBlock.doNotSplice = true;
        this._oldPrimitiveValue = valueBlock.getParam(0);
        valueBlock.destroy();
      } else if (this.acceptType === 'param') {
        this._destroyObservers();
        valueBlock.view._toGlobalCoordinate();
        block.getTerminateOutputBlock().view._contents[1].replace(valueBlock);
      } else {
        this._destroyObservers();
        valueBlock.view._toGlobalCoordinate();
        Entry["do"]('separateBlockByCommand', valueBlock).isPass(true);
        var board = this.getBoard();
        var _ref2 = board || {},
          _ref2$scale = _ref2.scale,
          scale = _ref2$scale === void 0 ? 1 : _ref2$scale;
        valueBlock.view.bumpAway(30 * scale, 150);
      }
      this.updateValueBlock(block);
      block.view._toLocalCoordinate(this);
      this.calcWH();
      this.changeEvent.notify();
    }
  }, {
    key: "setParent",
    value: function setParent(parent) {
      this._parent = parent;
    }
  }, {
    key: "getParent",
    value: function getParent() {
      return this._parent;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    }
  }, {
    key: "_createBlockByType",
    value: function _createBlockByType(blockType) {
      var board = this._blockView.getBoard();
      var selected = _.result(board.workspace, 'selectedBlockView');
      var isFromUserAction = false;
      if (selected) {
        isFromUserAction = !!_.result(selected, 'dragInstance');
      }
      var block = new Entry.Block({
        type: blockType,
        defaultType: this.defaultType,
        params: [isFromUserAction ? undefined : this._oldPrimitiveValue],
        copyable: blockType !== 'function_field_label'
      }, this);
      block.createView(board, this.renderMode);
      delete this._oldPrimitiveValue;
      return block;
    }
  }, {
    key: "_updateBG",
    value: function _updateBG() {
      if (this.magneting) {
        this._bg = this.svgGroup.elem('path', {
          d: 'm 8,12 l -4,0 -2,-2 0,-3 3,0 1,-1 0,-12 -1,-1 -3,0 0,-3 2,-2 l 4,0 z',
          fill: '#fff',
          stroke: '#fff',
          'fill-opacity': 0.7,
          transform: 'translate(0,12)'
        });
      } else {
        _.result(this._bg, 'remove');
        delete this._bg;
      }
    }
  }, {
    key: "getThread",
    value: function getThread() {
      return this;
    }
  }, {
    key: "getParentThread",
    value: function getParentThread() {
      return this._block.getThread();
    }
  }, {
    key: "pointer",
    value: function pointer() {
      var _pointer2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this._block.pointer([Entry.PARAM, this._index].concat((0, _toConsumableArray2["default"])(_pointer2)));
    }
  }, {
    key: "targetPointer",
    value: function targetPointer() {
      var pointer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _pointer = this._block.pointer([Entry.PARAM, this._index].concat((0, _toConsumableArray2["default"])(pointer)));
      return _pointer;
    }
  }, {
    key: "isParamBlockType",
    value: function isParamBlockType() {
      return true;
    }

    //check block schema and view
  }, {
    key: "_ensureBlock",
    value: function _ensureBlock(block) {
      if (!block) {
        return;
      }
      if (block.constructor !== Entry.Block) {
        block = new Entry.Block(block, this._block.thread);
      }

      //if block schema is not present
      //and can't load schema, then destroy and return undefined
      if (!block.getSchema()) {
        this._destroyObservers();
        block.destroy();
        return;
      }
      block.defaultType = this.defaultType;
      if (!block.view) {
        block.setThread(this);
        block.createView(this.getBoard(), this.renderMode);
        this.view.setParent(this);
      }
      return block;
    }
  }, {
    key: "getFields",
    value: function getFields() {
      if (!this._blockView) {
        return [];
      }
      return this._blockView.getFields();
    }
  }]);
}(Entry.Field);